import {
  isLocalObjectStoragePdfUrl,
  localObjectStorageProxyPath
} from "@/pages/people/[pgaId]/career/career-profile/_openCareerPlanPdf";

// Dev Active Storage URLs point at localhost:9000. From the temp site that host is the
// viewer's machine, so send the signed path through the Vite MinIO proxy instead.
export function electionExportDownloadUrl(url: string): string {
  return isLocalObjectStoragePdfUrl(url) ? localObjectStorageProxyPath(url) : url;
}
